import { render, staticRenderFns } from "./cModalMedicFrequency.vue?vue&type=template&id=5965c972&scoped=true"
import script from "./cModalMedicFrequency.vue?vue&type=script&lang=js"
export * from "./cModalMedicFrequency.vue?vue&type=script&lang=js"
import style0 from "./cModalMedicFrequency.vue?vue&type=style&index=0&id=5965c972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965c972",
  null
  
)

export default component.exports